"use strict";

function internalMessageDirective($sce) {
return {
    restrict: 'AE',
    replace: true,
    scope: {
      "publication": "=internalMessage",
      "saveAction": "&"
    },
    link: function(scope) {
      scope.trustAsHtml = function(string) {
        return $sce.trustAsHtml(string);
      };
    },
    templateUrl: "partials/company/publications/internal-message.html"
  };
}

angular.module('dokiv')
  .directive('internalMessage', ['$sce', internalMessageDirective]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/internalMessageDirective.js
// module id = 398
// module chunks = 0